import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DataProvider } from './context/DataProvider';

// Toastify imports
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';   // This line is REQUIRED

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DataProvider>
    <App />
    {/* THIS LINE WAS MISSING – now the toasts will appear! */}
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"                 // or "light" / "dark"
      // Optional: make it match your purple theme
      toastStyle={{
        background: 'linear-gradient(90deg, #6d28d9, #4c1d95)',
        color: 'white',
        fontWeight: '600',
        borderRadius: '12px',
      }}
      progressStyle={{ background: '#fff' }}
    />
    </DataProvider>
  </React.StrictMode>
);

reportWebVitals();